// // import React, { useState } from 'react';
// // import { connect } from 'react-redux';
// // import { Link, Navigate } from 'react-router-dom';
// // import { setAlert } from '../../actions/alert';
// // import { useDispatch } from 'react-redux';
// // import { register } from '../../actions/auth';
// // import PropTypes from 'prop-types';
// // import {ToastContainer} from 'react-toastify'
// // import {registerUser} from '../../actions/userActions'
// // import { validateForm } from '../../actions/userActions'
// // const Register = ({ setAlert, register, isAuthenticated }) => {
// //   const [formData, setFormData] = useState({
// //     name: '',
// //     email: '',
// //     password: '',
// //     password2: ''
// //   });


// //   const [form, setForm] = useState('')
// //   const [message, setMessage] = useState('')
// //   const [errors, setErrors] = useState('')


// // const dispatch = useDispatch()




// //   const handleSubmit = (e) => {
// //     e.preventDefault();

// //     setMessage('')


// //     const formErrors = validateForm()


// //     if(Object.keys(formErrors).length > 0){
// //       setErrors(formErrors)
// //       setMessage('Woa, check for errors; my head was spinning. The detail is in red.')
// //     } else {
// //       console.log(form)


// //       dispatch(registerUser(form))
// //     }


// //   }

// //   const { name, email, password, password2 } = formData;

// //   const onChange = (e) =>
// //     setFormData({ ...formData, [e.target.name]: e.target.value });

// //   const onSubmit = async (e) => {
// //     e.preventDefault();
// //     if (password !== password2) {
// //       setAlert('Passwords do not match', 'danger');
// //     } else {
// //       register({ name, email, password });
// //     }
// //   };

// //   if (isAuthenticated) {
// //     return <Navigate to={`/openai/m1/select/${name}`} />;
// //   }

// //   return (<>
// //     <section className="text">
// //       <h1 className="blog-header footer">
// //         <i className="fas fa-user" /> Create Your Account
// //       </h1>
// //       <form className="form" onSubmit={onSubmit}>

// //           <label for='name'>Name
// //           <input
// //             type="text"
// //             placeholder="Name"
// //             name="name"
// //             value={name}
// //             onChange={onChange}
// //           /></label>



// //      <label for="email">Email
// //           <input
// //             type="email"
// //             placeholder="Email Address"
// //             name="email"
// //             value={email}
// //             onChange={onChange}
// //           /></label><br/>


// // <label for='password'>Password

// //           <input
// //             type="password"
// //             placeholder="Password"
// //             name="password"
// //             value={password}
// //             onChange={onChange}
// //           /></label>

// //           <label for='password2'>Confirm Password
// //           <input
// //             type="password"
// //             placeholder="Confirm Password"
// //             name="password2"
// //             value={password2}
// //             onChange={onChange}
// //           /></label>



// // <section className='text btn footer buttons'>

// //         <input type="submit" className=" button mlot text fit" value="Register" />
// //         <input type="submit" className=" button mlot text fit" value="Back" />
// // </section>
// //         <div className='line fit'></div>
// //         <p className=" my-1 footer no-over  fit">
// //         Already have an account?   <Link to="/login" className='button'>Sign In</Link></p>
// //       </form>

      
// //     </section> 
    
// // <a className='back-link' href="/">back home</a>
    

        
      
// //  </> );
// // };

// // Register.propTypes = {
// //   setAlert: PropTypes.func.isRequired,
// //   register: PropTypes.func.isRequired,
// //   isAuthenticated: PropTypes.bool
// // };

// // const mapStateToProps = (state) => ({
// //   isAuthenticated: state.auth.isAuthenticated
// // });

// // export default connect(mapStateToProps, { setAlert, register })(Register);



// import React, { useState } from "react";
// import { Link, Navigate } from "react-router-dom";
// import { connect } from "react-redux";
// import { setAlert } from "../../actions/alert";
// import { register } from "../../actions/auth";
// import {ToastContainer, toast} from 'react-toastify'
// const Register = ({ register, isAuthenticated}) => {
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     password: "",
//     password2: ""
//   });

//   const { name, email, password, password2 } = formData;

//   const onChange = e =>
//     setFormData({ ...formData, [e.target.name]: e.target.value });

//   const onSubmit = async e => {
//     e.preventDefault();


//     try{ 
      
      
//       if(password !== password2){
//       toast.error("Passwords don't match")
  
//     }else{
//     const response = await register({name,email,password})
//     }


//     }catch(err){
//       alert(err)
//       toast.error(err)
//       console.log('ERROR IN ON SUBMIT FUNCTION',err)
//     }

//   };

//   if (isAuthenticated && password === password2) {
//     toast.success('Successfully registered account. Please login to use the API')
//     return <Navigate to="/login" />;
//   }

//   return (
//     <>
//       <h1 className="large text-primary">Sign Up</h1>
//       <form className="form" onSubmit={e => onSubmit(e)}>
//         <div className="form-group">
//           <input
//             type="text"
//             placeholder="Name"
//             name="name"
//             value={name}
//             onChange={e => onChange(e)}
//             required
//           />
//         </div>
//         <div className="form-group">
//           <input
//             type="email"
//             placeholder="Email Address"
//             name="email"
//             value={email}
//             onChange={e => onChange(e)}
//             required
//           />
 
//         </div>
//         <div className="form-group">
//           <input
//             type="password"
//             placeholder="Password"
//             name="password"
//             minLength="6"
//             value={password}
//             onChange={e => onChange(e)}
//             required
//           />
//         </div>
//         <div className="form-group">
//           <input
//             type="password"
//             placeholder="Confirm Password"
//             name="password2"
//             minLength="6"
//             value={password2}
//             onChange={e => onChange(e)}
//             required
//           />
//         </div>
//         <input type="submit" className="btn btn-primary" value="Register" />
//       </form>

//       <p className="my-1 no-over">
//         Already have an account? <Link to="/login">Sign In</Link>
//       </p>
//     </>
//   );
// };

// const mapStateToProps = state => ({
//   isAuthenticated: state.auth.isAuthenticated
// });

// export default connect(mapStateToProps, { setAlert, register })(Register);




// import React, { useState } from 'react';
// import axios from 'axios'


// export const register = async (formData) => {
//   try {
//     const config = {
//       headers: {
//         'Content-Type': 'application/json'
//       }
//     }

//     const body = JSON.stringify(formData);

//     const res = await axios.post('/api/authRoutes', formData, config);

//     return res.data;
//   } catch (err) {
//     console.error(err.response.data);
//   }
// }

// const Register = () => {
//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     password: '',
//     password2: ''
//   });

//   const { name, email, password, password2 } = formData;

//   const onChange = e =>
//     setFormData({ ...formData, [e.target.name]: e.target.value });

//   const onSubmit = e => {
//     e.preventDefault();
//     if (password !== password2) {
//       console.log('Passwords do not match');
//     } else {
//       console.log(formData);
//       register()
//     }
//   };

//   return (
//     <div>
//       <h1>Register</h1>
//       <form onSubmit={e => onSubmit(e)}>
//         <div>
//           <input
//             type='text'
//             placeholder='Name'
//             name='name'
//             value={name}
//             onChange={e => onChange(e)}
//             required
//           />
//         </div>
//         <div>
//           <input
//             type='email'
//             placeholder='Email Address'
//             name='email'
//             value={email}
//             onChange={e => onChange(e)}
//             required
//           />
//         </div>
//         <div>
//           <input
//             type='password'
//             placeholder='Password'
//             name='password'
//             value={password}
//             onChange={e => onChange(e)}
//             minLength='6'
//             required
//           />
//         </div>
//         <div>
//           <input
//             type='password'
//             placeholder='Confirm Password'
//             name='password2'
//             value={password2}
//             onChange={e => onChange(e)}
//             minLength='6'
//             required
//           />
//         </div>
//         <input type='submit' value='Register' />
//       </form>
//     </div>
//   );
// };

// export default Register;


import React, { useState } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { register } from '../../actions/auth';

const Register = ({ register, isAuthenticated }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    password2: ''
  });

  const { name, email, password, password2 } = formData;

  const onChange = e =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const onSubmit = async e => {
    e.preventDefault();
    if (password !== password2) {
      console.log('Passwords do not match');
    } else {
      register({ name, email, password });
    }
  };

  // Redirect if logged in
  if (isAuthenticated) {
    return <Navigate to='/login' />;
  }

  return (
    <div>
      <h1>Register</h1>
      <form onSubmit={e => onSubmit(e)} className="form">
        <div>
          <input
            type='text'
            placeholder='Name'
            name='name'
            value={name}
            onChange={e => onChange(e)}
            required
          />
        </div>
        <div>
          <input
            type='email'
            placeholder='Email Address'
            name='email'
            value={email}
            onChange={e => onChange(e)}
            required
          />
        </div>
        <div>
          <input
            type='password'
            placeholder='Password'
            name='password'
            value={password}
            onChange={e => onChange(e)}
            minLength='6'
            required
          />
        </div>
        <div>
          <input
            type='password'
            placeholder='Confirm Password'
            name='password2'
            value={password2}
            onChange={e => onChange(e)}
            minLength='6'
            required
          />
        </div>
        <input type='submit' value='Register' className='button mlot' />
      </form>
      <p className="no-over form-info">
        Already have an account? <Link to='/login' className='button'>Sign In</Link>
      </p>
    </div>
  );
};

Register.propTypes = {
  register: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool
};

const mapStateToProps = state => ({
  isAuthenticated: state.auth.isAuthenticated
});

export default connect(
  mapStateToProps,
  { register }
)(Register);
